import { storableError } from '../../util/errors';
import { saveConsent } from '../../util/api';

// The two consent types this screen captures — defined by the interview consent-status model,
// accepted by the existing (unmodified) saveConsent allow-list. This screen is a pure consumer of
// that endpoint.
export const AI_INTERVIEW_CONSENT_TYPES = ['AIInterviewProctoring', 'IdentityReVerification'];

// ================ Action types ================ //

export const SUBMIT_CONSENTS_REQUEST = 'app/AIInterviewConsentPage/SUBMIT_CONSENTS_REQUEST';
export const SUBMIT_CONSENTS_SUCCESS = 'app/AIInterviewConsentPage/SUBMIT_CONSENTS_SUCCESS';
export const SUBMIT_CONSENTS_ERROR = 'app/AIInterviewConsentPage/SUBMIT_CONSENTS_ERROR';

// ================ Reducer ================ //

const initialState = {
  submitInProgress: false,
  submitError: null,
  submitted: false,
};

export default function aiInterviewConsentPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SUBMIT_CONSENTS_REQUEST:
      return { ...state, submitInProgress: true, submitError: null };
    case SUBMIT_CONSENTS_SUCCESS:
      return { ...state, submitInProgress: false, submitted: true };
    case SUBMIT_CONSENTS_ERROR:
      return { ...state, submitInProgress: false, submitError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const submitConsentsRequest = () => ({ type: SUBMIT_CONSENTS_REQUEST });
export const submitConsentsSuccess = () => ({ type: SUBMIT_CONSENTS_SUCCESS });
export const submitConsentsError = e => ({ type: SUBMIT_CONSENTS_ERROR, error: true, payload: e });

// ================ Thunks ================ //

// Writes BOTH consent events via the existing, unmodified saveConsent wrapper — one call per
// consent type — then resolves. No new consent-handling code path is introduced by this screen,
// so existing consent behaviour stays backwards-compatible.
//
// `consentTexts` maps each consent type to the exact statement shown for it, so the audit trail
// stores what the candidate read rather than one summary standing in for both. `consentText`
// remains accepted as the fallback for callers that have only one string; per-type wins when both
// are supplied. The server versions policy text per `consentType`, so sending them separately is
// what lets the two statements version independently of each other.
export const submitConsents = ({ candidateListingId, jobListingId, skillFitCheckId, consentText, consentTexts, deviceUsed } = {}) => dispatch => {
  dispatch(submitConsentsRequest());
  return Promise.all(
    AI_INTERVIEW_CONSENT_TYPES.map(consentType =>
      saveConsent({
        consentType,
        candidateListingId,
        jobListingId,
        skillFitCheckId,
        consentText: (consentTexts && consentTexts[consentType]) || consentText,
        deviceUsed,
      })
    )
  )
    .then(() => {
      dispatch(submitConsentsSuccess());
      return true;
    })
    .catch(e => {
      dispatch(submitConsentsError(storableError(e)));
      throw e;
    });
};
